<div class="rechazar-container">

  <label class="nombre-prospecto">{{$nombreCompleto()}}</label>

  <div class="section">
    <label class="section-label">Contacto Al Prospecto:</label>
    <div class="flex gap-[var(--gap-semi)]">
      @for (option of tiposOptions; track option.value) {
      <app-radio [name]="'tipo-reprogramacion'" [value]="option.value" [label]="option.label"
        [ngModel]="$tipoSeleccionado()" (valueChange)="onTipoChange($event)" />
      }
    </div>
  </div>

  @if ($tipoSeleccionado() === '0') {
  <div class="section">
    <label class="section-label">Motivo de Rechazo</label>
    @if ($loadingCatalogos()) {
    <div class="loading-select">Cargando motivos...</div>
    } @else {
    <app-select [items]="$motivosRechazo()" [value]="$motivoSeleccionado()" (keyString)="onMotivoChange($event)"
      placeholder="Seleccionar motivo" hostWidth="100%" inputWidth="100%" />
    }
  </div>

  <div class="section">
    <label class="section-label">Observaciones</label>
    <textarea class="observaciones-input" [value]="$observaciones()" (input)="onObservacionesChange($event)" rows="4"
      placeholder=""></textarea>
  </div>
  } @else {
  <div class="section">
    <label class="section-label">¿Ya compró?</label>
    <div class="flex gap-[var(--gap-semi)]">
      @for (option of yaCompoOptions(); track option.value) {
      <app-radio [name]="'ya-compro'" [value]="option.value" [label]="option.label" [ngModel]="$yaCompro()"
        (valueChange)="onYaCompoChange($event)" />
      }
    </div>
  </div>

  @if ($yaCompro() === 'si') {
  <div class="section">
    <label class="section-label">¿Donde Compró?</label>
    <div class="flex flex-col gap-[var(--gap-semi)]">
      @for (option of $motivosDondeCompro(); track option.key) {
      <app-radio [name]="'donde-compro'" [value]="option.key" [label]="option.value" [ngModel]="$dondeCompro()"
        (valueChange)="onDondeCompoChange($event)" />
      }
    </div>
  </div>

  @if ($dondeCompro() !== '') {
  <div class="section">
    <label class="section-label">Motivo de Rechazo</label>
    @if ($loadingCatalogos()) {
    <div class="loading-select">Cargando motivos...</div>
    } @else {
    <app-select [items]="$motivosRechazo()" [value]="$motivoSeleccionado()" (keyString)="onMotivoChange($event)"
      placeholder="Seleccionar motivo" hostWidth="100%" inputWidth="100%" />
    }
  </div>

  @if (!$dondeComproMismaMarca()) {
  <div class="section">
    <label class="section-label">Marca de Rechazo</label>
    @if ($loadingMarcas()) {
    <div class="loading-select">Cargando marcas...</div>
    } @else {
    <app-select [items]="$marcas()" [value]="$marcaSeleccionada()" (keyString)="onMarcaChange($event)"
      placeholder="Seleccionar marca" hostWidth="100%" inputWidth="100%" />
    }
  </div>

  @if ($marcaSeleccionada() !== '') {
  <div class="section">
    <label class="section-label">Auto de Rechazo</label>
    @if ($loadingAutos()) {
    <div class="loading-select">Cargando autos...</div>
    } @else {
    <app-select [items]="$autos()" [value]="$autoSeleccionado()" (keyString)="onAutoChange($event)"
      placeholder="Seleccionar auto" hostWidth="100%" inputWidth="100%" />
    }
  </div>
  }
  }

  <div class="section">
    <label class="section-label">Observaciones</label>
    <textarea class="observaciones-input" [value]="$observaciones()" (input)="onObservacionesChange($event)" rows="4"
      placeholder=""></textarea>
  </div>
  }
  }

  @if ($yaCompro() === 'no') {
  <div class="section">
    <label class="section-label">¿Por qué no ha comprado?</label>
    <div class="flex flex-col gap-[var(--gap-semi)]">
      @for (option of $motivosPorqueNoCompra(); track option.key) {
      <app-radio [name]="'porque-no-compra'" [value]="option.key" [label]="option.value" [ngModel]="$porqueNoCompra()"
        (valueChange)="onPorqueNoCompraChange($event)" />
      }
    </div>
  </div>

  @if ($porqueNoCompra() !== '') {
  <div class="section">
    <label class="section-label">Motivo de Rechazo</label>
    @if ($loadingCatalogos()) {
    <div class="loading-select">Cargando motivos...</div>
    } @else {
    <app-select [items]="$motivosRechazo()" [value]="$motivoSeleccionado()" (keyString)="onMotivoChange($event)"
      placeholder="Seleccionar motivo" hostWidth="100%" inputWidth="100%" />
    }
  </div>

  <div class="section">
    <label class="section-label">Observaciones</label>
    <textarea class="observaciones-input" [value]="$observaciones()" (input)="onObservacionesChange($event)" rows="4"
      placeholder=""></textarea>
  </div>
  }
  }
  }
</div>

<div class="footer-actions">
  <app-button text="Rechazar" icon="close-circle-outline" [disabled]="!$puedeRechazar()"
    tooltipWhenDisabled="Seleccionar motivo y llenar observaciones" (click)="onRechazar()" />
</div>
